import { makeStyles } from 'tss-react/mui';

import { MOBILE_HEADER_HEIGHT } from '../MobileHeader';
import { SIDEBAR_WIDTH } from './constants';

interface ISideBarStylesProps {
  isMobileSideBar: boolean;
  topBannersHeight: number;
}

export const useStyles = makeStyles<ISideBarStylesProps>({ name: 'Sidebar' })(
  (theme, { isMobileSideBar, topBannersHeight }) => ({
    root: {
      position: isMobileSideBar ? 'relative' : 'fixed',
      zIndex: 3,

      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: isMobileSideBar ? theme.spacing(5) : theme.spacing(10),
      top: isMobileSideBar ? 0 : topBannersHeight,

      width: isMobileSideBar ? '100%' : SIDEBAR_WIDTH,
      height: isMobileSideBar
        ? `calc(100% - ${MOBILE_HEADER_HEIGHT}px)`
        : `calc(100vh - ${topBannersHeight}px)`,
      padding: isMobileSideBar
        ? theme.spacing(8, 4, 0, 4)
        : theme.spacing(8, 4, 4, 4),

      backgroundColor: theme.palette.background.paper,
      overflow: 'auto',
    },
    logo: {
      marginLeft: theme.spacing(3),
    },
    accountStatus: {
      width: 'auto',
    },
    balanceCard: {
      display: 'none',

      borderRadius: theme.shape.borderRadius,
      border: `1px solid ${theme.palette.grey[100]}`,
      padding: theme.spacing(4, 5),

      width: 312,

      [theme.breakpoints.down('md')]: {
        display: 'flex',
      },

      [theme.breakpoints.down('xs')]: {
        width: '100%',
      },
    },
  }),
);
